export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8382.5a4d6ec2.jpg";